module.exports = __webpack_public_path__ + "static/img/banner_lantern_slide_2.89c137e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner_lantern_slide_2.jpg
// module id = tXWD
// module chunks = 0